// extracted by mini-css-extract-plugin
export default {"newsletterSignUp":"j3z0rKkGE2RJ0aGX_wsl","privacy":"jrfVR0t36w7kB5bJQr2X","toggleButton":"CXJsl7Mrdjd6VCcl6f61"};